import CustomDatatableWithSearch from '../../libs/datatables/custom_datatable_with_search'
import initElementCardsFilter from '../../libs/element_cards_filter'

declare const $: any

export default function initShowWarehouse() {
  document.addEventListener('DOMContentLoaded', () => {
    // Initialize tables with search functionality
    const elementGroups = document.querySelectorAll('.element-group')
    
    elementGroups.forEach((elementGroup) => {
      const table = elementGroup.querySelector('table')
      const search = elementGroup.querySelector<HTMLInputElement>('input.search')
      const cards = elementGroup.querySelector<HTMLElement>('.element-cards')
      
      if (table && search) {
        let sort_column = table.dataset.sortColumn
        if (sort_column === undefined) {
          sort_column = '1'
        }
        const order = [[parseInt(sort_column), 'asc']]
        new CustomDatatableWithSearch($(table), $(search), { order, disableCompactMode: true })
      } else if (cards && search) {
        initElementCardsFilter({
          input: search,
          container: cards,
          emptyMessage: elementGroup.querySelector<HTMLElement>('.element-cards-no-match'),
        })
      }
    })
  })
}
